const Confirmation = () => {
  return <div>Confirmation</div>;
};

export default Confirmation;
